import React, { Component } from "react";
import Terminal from "react-console-emulator";

const commands = {
    whois: {
        description: 'returns my school, major, and background.',
        fn: function () {
            let input = Array.from(arguments).join(' ');
            input = input.toUpperCase();
            if (input === 'ANIKET') {
                return ("I'm a Purdue undergrad with " +
                    "background in full stack " +
                    "development (React, Spring, " +
                    "SQL).\n")
            } else {
                return ("Invalid parameter.\n\n" +
                    "Try one of these inputs:\nAniket\n\n" +
                    "For example, run 'whois Aniket'\n")
            }
        }
    },
    reveal: {
        description: 'returns specifics about me, like my stack.',
        fn: function () {
            if (arguments.length === 1) {
                if (arguments[0].toUpperCase() === "STACK") {
                    return ("Languages:\nJava, C, R, SQL, HTML/CSS\n\n" +
                        "Frameworks:\nReact, Spring\n\n" +
                        "Database:\nmySQL, AWS RDS, Firebase\n\n" +
                        "Deployment:\nAWS, Heroku, GitHub, Google Cloud\n\n" +
                        "Additional Tools:\n Git, UNIX, Maven, IPBurger\n")
                } else if (arguments[0].toUpperCase() === "HOBBIES") {
                    return ("Cars, PCs, anything tech.\n\n" +
                        "Oh, and how could I forget? Software!\n\n" +
                        "Always ready to chat about how something works " +
                        "over a cup of coffee.\n")
                } else if (arguments[0].toUpperCase() === "AWARDS") {
                    return ("• Techpoint S.O.S. Challenge Tourism Category Winner (July 2020)\n\n" +
                        "• Second Place Winner at JPMorgan Chase Technology for Social Good (Oct 2018)\n")
                }
            }
            return 'Invalid parameter.\n\n' +
                'Try one of these inputs:\nStack\nAwards\nHobbies\n\n' +
                'For example, run \'reveal Stack\'\n'
        }
    },
    parse: {
        description: 'parses my projects and returns an overview.',
        fn: function () {
            if (arguments.length === 1) {
                if (arguments[0].toUpperCase() === "INDIGO") {
                    return ("• Indigo is a web app built for collecting and " +
                        "displaying Indianapolis business responses to COVID-19.\n\n " +
                        "• Built using ReactJS, Spring Boot, and mySQL.\n\n" +
                        "• Presented to Governor of Indiana, Eric Holcomb.\n\n" +
                        "• Run 'open indigo --repo' for more information.\n")
                } else if (arguments[0].toUpperCase() === "PARTEM") {
                    return ("• Partem is a mobile app for predicting " +
                        "partisan bias in various media using Google Cloud ML and C#.\n\n" +
                        "• Run 'open partem --repo' for more information.\n")
                }
            }
            return 'Invalid parameter.\n\n' +
                'Try one of these inputs:\nIndigo\nPartem\n\n' +
                'For example, run \'parse Indigo\'\n'
        }
    },
    open: {
        description: 'opens my project repos or deployments, specified through flags.',
        fn: function () {
            if (arguments.length === 2) {
                if (arguments[0].toUpperCase() === "INDIGO") {
                    if (arguments[1].toUpperCase() === "-REPO") {
                        window.open('https://github.com/aniketagnihotri/Indigo',
                            '_blank')
                        return "Opened Indigo Repository...\n"
                    } else if (arguments[1].toUpperCase() === "-DEPLOYMENT") {
                        window.open('https://devpost.com/software/indigo-7rw30z',
                            '_blank')
                        return "Opened Indigo Devpost. Links provided for deployment.\n"
                    }
                } else if (arguments[0].toUpperCase() === "PARTEM") {
                    if (arguments[1].toUpperCase() === "-REPO") {
                        window.open('https://devpost.com/software/partem-tech',
                            '_blank')
                        return "Opened Partem Repository...\n"
                    } else if (arguments[1].toUpperCase() === "-DEPLOYMENT") {
                        return "Partem is a mobile app. Please use -repo to view.\n"
                    }
                }
            }
            return 'Invalid parameter or flag.\n\n' +
                'Try one of these inputs:\nIndigo\nPartem\n\n' +
                'Try one of these flags:\n-repo\n-deployment\n\n' +
                'For example, run \'open Indigo -repo\'\n'
        }
    },
    print: {
        description: 'prints a passed string.',
        fn: function () {
            let input = Array.from(arguments).join(' ')
            return input + "\n"
        }
    }
}

export default class TerminalComponentCompressed extends Component {
    render() {
        return (
            <Terminal
                autoFocus={true}
                style={{
                    display: 'flex',
                    cursor: 'text',
                    backgroundColor: '#FFFFFF',
                    borderRadius: 30
                }}
                contentStyle={{
                    height: '85vh',
                    fontSize: '14px',
                    color: '#000000',
                    fontFamily: 'monospace'
                }}
                inputAreaStyle={{
                    display: 'inline-flex',
                    width: '100%'
                }}
                promptLabelStyle={{
                    paddingTop: '0px',
                    color: '#000000'
                }}
                inputTextStyle={{
                    fontSize: '14px',
                    color: '#000000',
                    fontFamily: 'monospace'
                }}
                messageStyle={{
                    border: '0',
                    margin: '0',
                    flexGrow: '100',
                    width: '100%',
                    height: '22px',
                    color: '#007BFF',
                    background: 'transparent',
                    outline: 'none'
                }}
                commands={commands}
                welcomeMessage={'Run \'help\' to return commands.' +
                    ' Note that basic UNIX commands (e.g. cd and ls) are' +
                    ' disabled.\n'}
                promptLabel={'me@terminal_em:~$'}
            />
        );
    }
}
